import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

/**
 * Props for {@link ItemDetailSectionWrapper}.
 */
export interface ItemDetailSectionWrapperProps {
  children: React.ReactNode;
  title: string;
}

/**
 * Shared scaffolding for an item-detail panel section: a single-line heading
 * row followed by a caller-provided content slot. Used by `ItemDetailSection`
 * (badges / rows card), purchase history, related variant packs, and product
 * description — every section in the panel shares this title-row layout.
 *
 * @param props - {@link ItemDetailSectionWrapperProps}.
 * @returns The rendered wrapper.
 */
export const ItemDetailSectionWrapper: React.FC<
  ItemDetailSectionWrapperProps
> = ({ children, title }) => {
  const [styles] = useStyles();
  return (
    <View style={styles.wrapper}>
      <View style={styles.headingRow}>
        <Typography numberOfLines={1} variant="paragraph-base-600">
          {title}
        </Typography>
      </View>
      {children}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  headingRow: {
    flexDirection: 'row',
    paddingVertical: theme.sk.spacing.spaceSmall,
  },
  wrapper: {
    flexDirection: 'column',
    width: '100%',
  },
}));
